// store.js - ADD THIS
import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import rootReducer from './reducers';

const persistConfig = {
  key: 'master-naukri',
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  {},
  applyMiddleware(thunk)
);

// ✅ FORCE RESET showotp on EVERY load
// store.subscribe(() => {
//   const state = store.getState();
//   if (state.auth?.showotp === true) {
//     store.dispatch({ type: 'RESET_OTP_MODAL' });
//   }
// });

const persistor = persistStore(store);

export { persistor };
export default store;
